import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { Globals } from '../../_models/globals';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Subject, timer } from 'rxjs';
import { AccessSecurity } from '../../_models/accessSecurity';
import { ApiIntegration } from '../../_services/api.integration';
import Chart from 'chart.js';
import * as moment from 'moment';

declare var Chart: any;
declare var require: any;
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {
  accountOwners: any;
  tabClicked: string = "paid";
  orders: any = {};
  dateSelect: any;
  shipments: any;
  customersByOrder: any = [];
  customersByRevenue: any = [];
  accountOwner: any;
  invoice: any;
  topFiveProducts: any;
  shipmentByCarrierInfo: any;
  storeInfo: any;
  topFiveLocation: any;

  constructor(private alertService: AlertService, public g: Globals, public accessSec: AccessSecurity, public user: User, private router: Router, private api: ApiIntegration) {
    this.g.page = "Dashboard";
    this.g.accountOwnerName = this.user.accountOwnerName;
    /* this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
    }); */
    this.getCountDataByDate();
    //this.dateSelect = { label: 'Today', fromDate: moment().format('MM/DD/YYYY'), toDate: moment().format('MM/DD/YYYY') };

    this.api.getOrderByStore().subscribe((data: any) => {
      this.storeInfo = data.orderByResponseList;
    }, err => {
      console.log(err);
    });

    this.api.getShipmentsByCarriers().subscribe((data: any) => {
      this.shipmentByCarrierInfo = data.carrierResponseList;
    }, err => {
      console.log(err);
    });

    this.api.organizationsTop5Products().subscribe((data: any) => {
      this.topFiveProducts = data;
      this.topFiveLocation = data.locations;
    }, err => {
      console.log(err);
    });

    this.api.getTopFiveOrderDeliveredLocations().subscribe((data: any) => {
      this.topFiveLocation = data.locations;
    }, err => {
      console.log(err);
    });

  }

  getCountDataByDate() {
    if (!this.dateSelect) {
      this.dateSelect = {
        label: 'Today',
        fromDate: moment().format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      };
    }
    let query: any = {
      organizationId: 1
    }
    query = { ...query, ...this.dateSelect };
    delete query.label;
    this.api.getOrdersCount().subscribe((data: any) => {
      this.orders = data;
    }, err => {
      console.log(err);
    });
    this.getInvoiceDetails();
  }

  shipmentByCarrier() {
    this.api.getShipmentsByCarriers().subscribe((data: any) => {
      this.shipmentByCarrierInfo = data.carrierResponseList;
    }, err => {
      console.log(err);
    });
  }

  getOrderByStore() {
    this.api.getOrderByStore().subscribe((data: any) => {
      this.storeInfo = data.orderByResponseList;
    }, err => {
      console.log(err);
    });
  }

  top5Products() {
    this.api.organizationsTop5Products().subscribe((data: any) => {
      this.topFiveProducts = data;
    }, err => {
      console.log(err);
    });
  }

  top5Locations() {
    this.api.getTopFiveOrderDeliveredLocations().subscribe((data: any) => {
      this.topFiveLocation = data.locations;
    }, err => {
      console.log(err);
    });
  }


  getInvoiceDetails() {
    this.api.getCustomerAccountingSummary().subscribe((data: any) => {
      this.invoice = data;
    }, err => {
      console.log(err);
    });
  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
  }


  ngOnInit() {
  }

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  navigateToOrder(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/adminOrder']);
  }

  navigateToShipment() {
    this.router.navigate(['/admin/adminShipmentList']);
  }

  navigateToProduct(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/adminProducts']);
  }

  navigateToInvoice(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/adminInvoice']);
  }

  initializeCharts(query: any) {
    this.api.getOrdersCount().subscribe((data: any) => {
      this.orders = data;
    }, err => {
      console.log(err);
    });
    this.api.getShipmentsCount().subscribe((data: any) => {
      this.shipments = data;
    }, err => {
      console.log(err);
    });
  }

  getList() {
    let query: any = {
      organizationId: 1,
      fromDate: moment().format('MM/DD/YYYY')
    }
    if (this.accountOwner) {
      query.accountOwnerId = this.accountOwner;
    }
    this.initializeCharts(query);
    this.shipmentByCarrier();
    this.getOrderByStore();
    this.top5Products();
    this.top5Locations();

  }
}

